const spacing = {
  small: "8px",
  medium: "16px",
  large: "24px",
  xlarge: "32px",
};

export default spacing;
